import {inject, Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {map, Observable, zip} from 'rxjs';
import {CommonBlobStorageService} from '../../shared/services/blob-storage/common-blob-storage.service';
import {SpinnerOverlayService} from '../../shared/services/spinner-overlay/spinner-overlay.service';
import {IndustrySegmentService} from '../../shared/services/industry-segment/industry-segment.service';

@Injectable({
  providedIn: 'root',
})
export class CustomersGuard {
  private compassBlobStorageService = inject(CommonBlobStorageService);
  private spinner = inject(SpinnerOverlayService);
  private industrySegmentService = inject(IndustrySegmentService);

  canActivate(
    _route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot
  ): Observable<boolean> {
    return this.spinner.performWithSpinner(zip(
      this.compassBlobStorageService.loadBlobStorageConfiguration(),
      this.industrySegmentService.loadIndustrySegment(false)
    ).pipe(map(() => {
      return true;
    })));
  }
}
